import AppRoutes from "./routes/AppRoutes.jsx";

const App = () => {
  return <AppRoutes />;
};

export default App;